const initProduct = () => {
    const productWidget = document.querySelector("[data-product-widget]");
    if (productWidget) {
        const carouselSelector = document.querySelector("[data-gallery-images]");
        const carousel = new Flickity(carouselSelector, {
            wrapAround: true,
            prevNextButtons: false,
            pageDots: false,
            imagesLoaded: true,
        });
        const carouselNav = document.querySelector('[data-preview-images]');
        const carouselNavCells = carouselNav.querySelectorAll('[data-slide]');
        // change .entries
        for (const [i, carouselNavCell] of carouselNavCells.entries()) {
            carouselNavCell.addEventListener('click', function (event) {
                const index = carouselNavCell;
                carousel.select(i);
            });
        }
        const flkty = Flickity.data(carouselSelector);
        carousel.on('select', function (index) {
            for (let i = 0; i < carouselNavCells.length; i++) {
                carouselNavCells[i].classList.remove('is-nav-selected');
            }
            // change .entries or use IE polyfill
            for (const [i, carouselNavCell] of carouselNavCells.entries()) {
                if (i === flkty.selectedIndex) {
                    carouselNavCell.classList.add("is-nav-selected");
                }
            }
            const selected = carouselNav.querySelector('.is-nav-selected');
        });
    }
};
